module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAAAPCAYAAACyTgIjAAAAh0lEQVRYhe2XUQ6AIAxDnfH+V1b3MTObOYPGYDreFwgkrKEFZd2ZBifm3hv4I0OUgKX3Br5CRI52lBB+HOdQiqIF+yLv+vithH20WDwZGSVEaYXSPkiUH+UyBYu+so8JgWOUoijZmxSD1kQrFbSt0IriLRFdwela5n8fE6b18UYtylNo7fOGDdJ3RRcPmMFQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/qhtb1-3.png
// module id = 707
// module chunks = 0